// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"8c13907d","213":"8c13907d"}[chunkId] + ".chunk.css";
};